import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormSection } from 'react/containers/layout/Crud';
import Loading from 'react/components/Loading';
import { Button } from 'onefaceui-react-components';
import AlertGenericModal from 'react/containers/modals/AlertGenericModal';
import CommentsAddModal from 'react/containers/pages/TicketDetails/TicketDetailsContainer/CommentsAddModal';
import { resourceFrom, formatDate, checkIfDataExist } from 'react/containers/pages/TicketDetails/ticketDetailsUtils';
import resources from 'react/containers/pages/TicketDetails/ticketDetailsResources';

const renderContent = (data, renderEditDeleteContent) => {
  if (!data?.get?.('id')) {
    return <div>{resourceFrom(resources.dataNotFound)}</div>;
  }

  if (data?.get?.('comments')?.size) {
    return (
      <div className="commentsSection__container">
        {data.get('comments').map((comment) => (
          <div key={comment?.get('id')} className="commentsSection__comment">
            <div className="commentsSection__header">
              <div className="commentsSection__title">
                <span>
                  <b>{comment?.getIn(['userCreated', 'name']) ?? 'Unknown user'}</b>
                  &nbsp;
                </span>
                <span>
                  {resourceFrom(resources.addedAComment)}
                </span>
                <span>{` - ${formatDate(comment?.get('when'))}`}</span>
              </div>
              <div className="commentsSection__actions">
                {renderEditDeleteContent(comment)}
              </div>
            </div>
            <div className="commentsSection__message">
              {checkIfDataExist(comment?.get('note'))}
            </div>
          </div>
        ))}
      </div>
    );
  }

  return <div>{resourceFrom(resources.noComments)}</div>;
};

function CommentsSection(props) {
  const {
    isLoading, data, isProcessingComment, handleDeleteCommentAction,
    tab: { key: screenKey }, userLoggedId
  } = props;
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [commentToEdit, setCommentToEdit] = useState(null);
  const [alertModalToDelete, setAlertModalToDelete] = useState(false);
  const [commentToDelete, setCommentToDelete] = useState(null);

  const processingClass = isProcessingComment ? 'submitting' : '';

  const alertToDeleteModalConfig = {
    title: null,
    confirmClickButton: () => {
      handleDeleteCommentAction({ screenKey, commentToDelete });
      setAlertModalToDelete(false);
    },
    cancelClickButton: () => setAlertModalToDelete(false)
  };

  const onClickOpenModal = (e, comment) => {
    e.preventDefault();
    if (comment?.get('id')) {
      setCommentToEdit(comment);
    }
    setModalIsOpen(true);
  };

  const proccessDeleteComment = (e, comment) => {
    e.preventDefault();

    setCommentToDelete(comment);
    setAlertModalToDelete(true);
  };

  const renderEditDeleteContent = useCallback((comment) => {
    if (userLoggedId === comment?.getIn(['userCreated', 'id'])) {
      return (
        <>
          <span
            className="table-action-editlink"
            onClick={(e) => onClickOpenModal(e, comment)}
          />
          <span
            className="table-action-destroylink"
            onClick={(e) => proccessDeleteComment(e, comment)}
          />
        </>
      );
    }

    return null;
  }, [userLoggedId]);

  return (
    <>
      <CommentsAddModal
        modalIsOpen={modalIsOpen}
        setModalIsOpen={setModalIsOpen}
        commentToEdit={commentToEdit}
        setCommentToEdit={setCommentToEdit}
        {...props}
      />
      <FormSection title={resourceFrom(resources.commentSectionTitle)} className="commentsSection">
        {isLoading
          ? <Loading />
          : renderContent(data, renderEditDeleteContent)}
        <Button type="primary" className={`addItem ${processingClass}`} onClick={onClickOpenModal} disabled={!data?.get}>
          {resourceFrom(resources.addCommentButton)}
        </Button>
        <AlertGenericModal
          open={alertModalToDelete}
          i18n={Monet.I18n}
          message={resourceFrom(resources.alertToDeleteCommentQuestion)}
          {...alertToDeleteModalConfig}
        />
      </FormSection>
    </>
  );
}

CommentsSection.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  data: PropTypes.object,
  isProcessingComment: PropTypes.bool.isRequired,
  handleDeleteCommentAction: PropTypes.func.isRequired,
  tab: PropTypes.shape({
    key: PropTypes.string.isRequired
  }),
  userLoggedId: PropTypes.number.isRequired
};

CommentsSection.defaultProps = {
  tab: {},
  data: {}
};

export default CommentsSection;
